export default "__VITE_ASSET__D5yh$sqL__"